<mat-form-field appearance="outline" floatLabel="always" class="tags-input w-100">
  <mat-label>{{ "tags.label" | translate }}</mat-label>
  <mat-chip-list #chipList [disabled]="disabled" [attr.aria-label]="'tags.label' | translate">
    <mat-chip *ngFor="let tag of tags" [removable]="!disabled" (removed)="remove(tag)">
      {{ tag }}
      <mat-icon matChipRemove *ngIf="!disabled">cancel</mat-icon>
    </mat-chip>
    <input #tagInput
           [placeholder]="(tags?.length ? '' : ('tags.placeholder' | translate))"
           [(ngModel)]="text"
           [ngModelOptions]="{ standalone: true }"
           [maxlength]="maxTagLength"
           [disabled]="disabled"
           [matAutocomplete]="tagAuto"
           [matChipInputFor]="chipList"
           [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
           [matChipInputAddOnBlur]="false"
           (matChipInputTokenEnd)="onTokenEnd($event)"
           (keydown.backspace)="onBackspace()">
  </mat-chip-list>
  <mat-autocomplete #tagAuto="matAutocomplete" (optionSelected)="onSelected($event)" class="tags-input__panel">
    <mat-option *ngFor="let tag of suggestions" [value]="tag.name" class="tags-input__option">
      <span class="tags-input__name">{{ tag.name }}</span>
      <span class="tags-input__count">{{ tag.count }}</span>
      <mat-icon *ngIf="canRename"
                class="tags-input__action"
                [matTooltip]="'tags.renameEverywhere' | translate"
                (mousedown)="$event.preventDefault()"
                (click)="rename(tag, $event)">edit</mat-icon>
      <mat-icon *ngIf="canDelete"
                class="tags-input__action tags-input__action--danger"
                [matTooltip]="'tags.deleteEverywhere' | translate"
                (mousedown)="$event.preventDefault()"
                (click)="delete(tag, $event)">delete_outline</mat-icon>
    </mat-option>
    <mat-option *ngIf="canAddTyped" [value]="text" class="tags-input__option tags-input__option--add">
      <mat-icon>add</mat-icon>
      <span>{{ "tags.addNew" | translate: { name: text.trim() } }}</span>
    </mat-option>
  </mat-autocomplete>
  <mat-hint>{{ "tags.hint" | translate }}</mat-hint>
</mat-form-field>
